<!--
  - Copyright (c) 2022. Haodong JU
  -->

<template>
  <ik-data-table
    ref="zbon"
    :entity-name="$t('Zbon_list')"
    :icon="'mdi-format-list-bulleted'"
    :model="Zbon"
    :use-customer-action-only="true"
    :use-default-action="false"
    :use-select="true"
  >
    <template #footer>
      <v-btn
        class="mr-2"
        color="success"
        dark
        elevation="0"
        @click="outputPdf()"
      >
        {{ $t('pdf') }}
      </v-btn>
      <v-btn
        class="mr-2"
        color="primary"
        dark
        elevation="0"
        @click="print()"
      >
        {{ $t('print') }}
      </v-btn>
    </template>
    <template #item.action="{ item }">
      <v-icon
        class="mr-2"
        small
        @click="printSingleItem(item)"
      >
        mdi-printer
      </v-icon>
      <v-icon
        class="mr-2"
        small
        @click="generateZBonPDF(item)"
      >
        mdi-file-pdf-box
      </v-icon>
    </template>
  </ik-data-table>
</template>

<script>

  import { printZBon, reprintZbon } from '@/common/Utlis/api'
  import Utils from '../../../common/Utlis/Utils'
  import Zbon from '../../../model/export/Zbon'
  import { IkDataTable } from 'metaflow-js'
  import GlobalConfig from '../../../GlobalSettings'

  export default {
    components: { IkDataTable },
    data: function () {
      return ({
        Zbon: Zbon,
      })
    },
    methods: {
      print () {
        Utils.showConfirm('Bist du sicher?', 'Möchten Sie alle Datensätze drucken?', () => {
          printZBon().then(() => {
            Utils.toast('Erfolgreich drucken!')

            this.$refs.zbon.reload()
          })
        })
      },
      async generateZBonPDF (item) {
        window.open(GlobalConfig.getEndPoint() + 'ZBon.php?op=exportPDF&id=' + item.id)
        // await hillo.get('', { id: item.id })
      },
      async outputPdf () {
        const selectedItemIds = this.$refs.zbon.$data.selectedItems.reduce((arr, i) => {
          arr.push(i.id)
          return arr
        }, []).join(',')
        console.log(selectedItemIds)
        this.Zbon.outputMultiplePDF(selectedItemIds)
      },

      printSingleItem (item) {
        Utils.showConfirm('Bist du sicher?', 'Möchten Sie dieser Rekord drucken?', () => {
          reprintZbon(item.id).then(() => {
            Utils.toast('Erfolgreich drucken!')
            this.$refs.zbon.reload()
          })
        })
      },
    },
  }
</script>
